import { Component, Input, OnInit, inject } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { EffectivenessModel, WorkflowStepPermissionModel } from "../../shared/models";
import { EffectivenessPageType, EffectivenessStatusType } from "../../shared/enums";
import { AdvEffDataService, AdvEffWorkflowDataService } from "../../shared/services";
import { EffWorkFlowService, EffWorkFlowState } from "../common/services/eff-workflow.service";
import { firstValueFrom } from "rxjs";
import { EffWorkflowStatusComponent } from "../eff-workflow-status/eff-workflow-status.component";
import { EffDetailBreadcrumbInfoComponent } from "../eff-detail-breadcrumb-info/eff-detail-breadcrumb-info.component";
import { EffTestingUploadSourceDocumentComponent } from "../status-components/eff-testing-upload-source-document/eff-testing-upload-source-document.component";
import { EffTestingUploadEvidenceComponent } from "../status-components/eff-testing-upload-evidence/eff-testing-upload-evidence.component";
import { EffTestingTestComponent } from "../status-components/eff-testing-test/eff-testing-test.component";
import { EffTestingReviewComponent } from "../status-components/eff-testing-review/eff-testing-review.component";
import { EffTestingCompletedComponent } from "../status-components/eff-testing-completed/eff-testing-completed.component";

@Component({
    selector: "eff-detail-main",
    templateUrl: "./eff-detail-main.component.html",
    styleUrls: ["./eff-detail-main.component.scss"],
    imports: [
        EffWorkflowStatusComponent,
        EffDetailBreadcrumbInfoComponent,
        EffTestingUploadSourceDocumentComponent,
        EffTestingUploadEvidenceComponent,
        EffTestingTestComponent,
        EffTestingReviewComponent,
        EffTestingCompletedComponent,
    ]
})
export class EffDetailMainComponent implements OnInit {
    private _ds = inject(AdvEffDataService);
    private _workflowDs = inject(AdvEffWorkflowDataService);
    private _effWorkFlowService = inject(EffWorkFlowService);

    @Input() cerrixTab: TabModel;
    @Input() effectivenessGuid: string;

    effectivenessModel: EffectivenessModel;
    stepPermissions: WorkflowStepPermissionModel;
    workFlowSteps: EffWorkFlowState[];
    showReviewColumn: boolean;

    currentPage: EffectivenessPageType = EffectivenessPageType.NotStarted;
    currentPageState: EffWorkFlowState;
    pageTypes = EffectivenessPageType;

    async ngOnInit() {
        try {
            var eff = await firstValueFrom(this._ds.getEffectiveness(this.effectivenessGuid));
            this.effectivenessModel = eff;
            this.workFlowSteps = await this._effWorkFlowService.getWorkFlowSteps(eff);
            if (this.workFlowSteps.find((x) => x.stepId == EffectivenessPageType.Review)) {
                this.showReviewColumn = true;
            }
            this.currentPage = this.determinePageType();
            this.currentPageState = this.workFlowSteps.find((s) => s.stepId == this.currentPage);
            this.cerrixTab.name = eff.groupName + " | " + eff.name;
            this.stepPermissions = await firstValueFrom(
                this._workflowDs.getWorkflowStepPermission(this.effectivenessGuid),
            );
        } catch {
            this.cerrixTab.close(false);
        }
    }

    private determinePageType() {
        switch (this.effectivenessModel.status) {
            case EffectivenessStatusType.waitingForSourceDocuments:
                return EffectivenessPageType.UploadSourceDocuments;
            case EffectivenessStatusType.waitingForSamples:
                return EffectivenessPageType.UploadSourceDocuments;
            case EffectivenessStatusType.requestEvidence:
                return EffectivenessPageType.UploadEvidence;
            case EffectivenessStatusType.readyForAssessment:
            case EffectivenessStatusType.assessmentInProgress:
            case EffectivenessStatusType.waitingForConclusion:
            case EffectivenessStatusType.nonOccurrence:
                return EffectivenessPageType.Test;
            case EffectivenessStatusType.waitingForReviewer:
            case EffectivenessStatusType.reviewNonOccurrence:
                return EffectivenessPageType.Review;
            case EffectivenessStatusType.completed:
            case EffectivenessStatusType.nonOccurrenceCompleted:
                return EffectivenessPageType.Completed;
            case EffectivenessStatusType.undefined:
                return EffectivenessPageType.NotStarted;
        }
    }
}
